//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Saves a Blob as a file through a temporary link. Same pattern as the Support page's
 * diagnostic download: the object URL is checked to be a `blob:` URL before it is used
 * (CWE-601), and the file name has path characters removed.
 */
export const saveBlobAsFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  if (!String(url).startsWith('blob:')) {
    window.URL.revokeObjectURL(url);
    throw new Error('Refusing to download from a non-blob URL');
  }
  const link = document.createElement('a');
  link.href = String(url);
  link.download = fileName.replace(/[/\\:\0]/g, '_');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(url), 100);
};
